module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-row', {
    staticClass: "headTop"
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticClass: "goBack",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返回上一级")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "offset": 20
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "type": "success",
      "icon": "el-icon-circle-plus-outline"
    },
    on: {
      "click": function($event) {
        return _vm.showDialog()
      }
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "推荐信息",
      "visible": _vm.dialogVisible2,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparamInfo",
    attrs: {
      "model": _vm.formparamInfo,
      "rules": _vm.rules2,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "推荐名称",
      "prop": "name"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparamInfo.shortName),
      callback: function($$v) {
        _vm.$set(_vm.formparamInfo, "shortName", $$v)
      },
      expression: "formparamInfo.shortName"
    }
  }, _vm._l((this.getPtClassList), function(item) {
    return _c('el-option', {
      key: item.shortName,
      attrs: {
        "label": item.name,
        "value": item.shortName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推荐数量",
      "prop": "number"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入推荐数量"
    },
    model: {
      value: (_vm.formparamInfo.number),
      callback: function($$v) {
        _vm.$set(_vm.formparamInfo, "number", _vm._n($$v))
      },
      expression: "formparamInfo.number"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('formparamInfo')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitSetInfo('formparamInfo')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData2,
      "height": "73vh",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐大类"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(" " + _vm._s(scope.row.typename) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐项目"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(" " + _vm._s(scope.row.name) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分店"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(" " + _vm._s(_vm._f("caseType")(scope.row.shopnum)) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(" " + _vm._s(scope.row.number) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.remove(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pageination",
    staticStyle: {
      "display": "none"
    }
  }, [_c('el-col', [_c('el-pagination', {
    staticStyle: {
      "textAlign": "center",
      "marginTop": "10px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 40, 80, 100],
      "page-size": 20,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": this.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-29964906"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/hotRecom/hotInfo.vue
// module id = 593
// module chunks = 70